<template>
    <v-content>
        <v-breadcrumbs :items="breadcrumbsItems" large></v-breadcrumbs>

        <v-row>
            <v-col cols="12"
                   sm="6"
                   md="3"
                   xl="2"
                   v-for="title in snackbar.dashboardItems"
                   :key="title.link">
                <router-link :to="`branchAdminDashboard/${title.id}`" v-if="title.count">
                    <v-card :elevation="10" class="text-center custom-design" height="150" width="300">
                        <v-list-item link>
                            <v-list-item-content>
                                <v-list-item-title class="subtitle-1 pa-4">
                                    <div>
                                        <span>{{ title.name }}</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="custom-footer">
                            <v-list-item-content>
                                <v-divider></v-divider>
                                <v-list-item-title class="card-footer subtitle-1 pa-4">
                                    <div>
                                        <span>{{ $t('total') }} {{ $t('branch') }} : {{ title.count }}</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </router-link>
                <v-card v-else :elevation="10" class="text-center custom-design" height="150" width="300">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-1 pa-4">
                                <div>
                                    <span>{{ title.name }}</span>
                                </div>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="custom-footer">
                        <v-list-item-content>
                            <v-divider></v-divider>
                            <v-list-item-title class="card-footer subtitle-1 pa-4">
                                <div>
                                    <span>{{ $t('total') }} {{ $t('branch') }} : {{ title.count }}</span>
                                </div>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </v-col>
        </v-row>

    </v-content>
</template>

<script>
    /*import CompanyDashboardMenu from "./CompanyDashboardMenu";*/
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: "CompanySettings",
        computed:{
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),

           
            breadcrumbsItems() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: this.usersData.dashBoard,
                        exact: true
                    },
                    {
                        text: this.$t('provisional_offices'),
                        disabled: true,
                        to: "/CompanyList",
                        exact: true
                    }
                ]
            },

        },
        data() {
            return {
                snackbar: {
                    formModal: false,
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    drawer: null,
                    drawerRight: null,
                    right: false,
                    dashboardItems: [],
                    breadcrumbsItems: [],
                },
                customerData: {
                    updateItem: {}
                },
                branchInformation: [],
            }
        },
        methods: {
            clickEvent(route) {
                this.$router.push({name: route})
            },
            addFormModal(route) {
                this.snackbar.formModal = true
                this.dynamicComponent.current = route
            },
            dialogueClose() {
                this.customerData.updateItem = {}
                this.snackbar.formModal = false
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
            },
            openDrawer() {
                this.snackbar.drawerRight = !this.snackbar.drawerRight
            },
            async dashboardData() {
              
                //this.snackbar.breadcrumbsItems=[
                //    {
                //        text: "Dashboard",
                //        disabled: false,
                //        to: this.usersData.dashBoard,
                //        exact: true
                //    },
                //    {
                //        text: "Provisional offices",
                //        disabled: true,
                //        to: "/CompanyList",
                //        exact: true
                //    }
                //]
                axios.get("Company/CompanyBranchCount", {
                    params: {
                        CompanyID: this.$store.getters.getUserData.companyID
                    }
                }).then(response => {
                    let dashboardItems = response.data
                    console.log("information", dashboardItems)
                    this.snackbar.dashboardItems = dashboardItems.list
                })
            }
        },
        mounted() {
            this.dashboardData()
        },
        components: {
            /* 'menu-list': CompanyDashboardMenu,*/
            /*// eslint-disable-next-line vue/no-unused-components
            'CompanyForm': () => import(/!* webpackChunkName: "CompanyForm" *!/ '../company/airDestination/CompanyForm'),
            // eslint-disable-next-line vue/no-unused-components
            'SectionsForm': () => import(/!* webpackChunkName: "SectionsForm" *!/ '../company/Sections/SectionsForm'),
            // eslint-disable-next-line vue/no-unused-components
            'PeriodicBudgetForm': () => import(/!* webpackChunkName: "PeriodicBudgetForm" *!/ '../company/PeriodicBudget/PeriodicBudgetForm'),
            // eslint-disable-next-line vue/no-unused-components
            'CustomerForm': () => import(/!* webpackChunkName: "CustomerForm" *!/ '../company/customer/CustomerForm')*/
        }
    }
</script>

<style scoped lang="scss">
    .options {
        border: 2px solid white;
    }
    .custom-design {
        transition: transform 0.2s, box-shadow 0.2s; /* Add box-shadow to the transition */
        cursor: pointer;
        box-shadow: 0 0 0 transparent; /* Start with no shadow */
        background: deepskyblue !important;
    }

    .custom-design:hover {
        transform: scale(1.03);
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.5); /* Add a shadow on hover */
    }
    .card-footer {
        background-color: #f0f0f0;
        background: linear-gradient(to bottom, #efeeed7a, #b3b3b3);
    }
    .custom-footer {
        padding-top: 0.6rem;
        padding-left: 0px;
        padding-right: 0px
    }
</style>
